// extracted by mini-css-extract-plugin
export default {"selectItemsToShow":"table_selectItemsToShow__gkLiG"};